import {ButtonBase, ButtonColors, ConcreteButtonProps} from "./button-base";
import React from "react";
import {observer} from "mobx-react-lite";
import {useServices} from "../../hooks/use-services.hook";


interface PrimaryShadeButtonProps extends ConcreteButtonProps {
}

export const PrimaryShadeButton: React.FC<PrimaryShadeButtonProps> = observer((props) => {
    const services = useServices();
    const themeColors = services.theme.currentTheme.colors;

    const buttonColors: ButtonColors = {
        $background: themeColors.primaryShade,
        $color: themeColors.primaryContrast,
        $border: themeColors.primaryShade,
        $backgroundActivated: themeColors.primaryContrast,
        $colorActivated: themeColors.primaryShade,
        $borderActivated: themeColors.primaryShade
    }
    return (
        <ButtonBase {...props} colors={buttonColors}>
            {props.children}
        </ButtonBase>
    );
});
